import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'tvcore-ivv-title',
	templateUrl: './ivv-title.component.html',
	styleUrls: ['./ivv-title.component.scss'],
	imports: [TranslateModule],
})
export class IvvTitleComponent {
	@Input()
	title: string;
	@Input()
	year: string | number | null;

	readonly CURRENT_YEAR = new Date().getFullYear();
}
